/** Shared confirm / toast helpers for vendor panel actions. */
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

function showToast(vm, { title, text, variant, icon, timeout }) {
  if (!vm || typeof vm.$toast !== 'function') return null
  return vm.$toast(
    {
      component: ToastificationContent,
      props: {
        title,
        text,
        variant,
        icon,
      },
    },
    {
      timeout,
      position: 'top-right',
    },
  )
}

export function confirmAction(vm, { title, text, confirmButtonText = 'Yes' }, onConfirm) {
  return vm.$swal({
    title,
    text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText: 'Cancel',
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-outline-danger ml-1',
    },
    buttonsStyling: false,
  }).then(result => {
    if (result.isConfirmed && typeof onConfirm === 'function') {
      return onConfirm()
    }
    return null
  })
}

export function notifySuccess(vm, text, title = 'Done') {
  return showToast(vm, {
    title,
    text,
    variant: 'success',
    icon: 'CheckIcon',
    timeout: 3000,
  })
}

export function notifyInfo(vm, text, title = 'Notice') {
  return showToast(vm, {
    title,
    text,
    variant: 'info',
    icon: 'InfoIcon',
    timeout: 3000,
  })
}

export function notifyError(vm, text, title = 'Error') {
  return showToast(vm, {
    title,
    text,
    variant: 'danger',
    icon: 'AlertCircleIcon',
    timeout: 4000,
  })
}
